const translatedTextsModel = {
  name: 'translatedTextsModel',
  state: {},
  reducers: {
    setTranslatedTexts(state, translatedTexts: string[]) {
      return { ...state, ...translatedTexts };
    },
  },
  effects: dispatch => ({
    // Add any asynchronous side effects here if needed
  }),
};

export default translatedTextsModel;
